import PIcon from '@comp/project/icon/PIcon'

export default {
  install(Vue) {
    Vue.component(PIcon.name, PIcon)
  }
}
